import * as React from 'react';
import { ReactNode } from 'react';
import { StandardTextFieldProps } from '@material-ui/core/TextField/TextField';
import { FieldError } from '../api/restApi';
import { FormHelperText } from '@material-ui/core';
import { translation } from '../i18n';

export function renderErrors(errors: FieldError[]): ReactNode {
  return errors.map((e, i) => <React.Fragment key={i}>{i > 0 && <br/>}{translation.t('validationErrors.' + e.code + '.' + e.field)}</React.Fragment>);
}

export function getErrorMessages(errors: FieldError[]): string {
  let msg: string = '';
  errors.map((e, i) => {
    if (i > 0) {
      msg = msg + '/n';
    }
    msg = msg + translation.t('validationErrors.' + e.code + '.' + e.field)
  });
  return msg;
}

export function renderRemainingErrors(errors: FieldError[]): ReactNode {
  return errors.map((e, i) => (
    <FormHelperText key={i} error={true}>
      {translation.t('validationErrors.' + e.code + '.' + e.field)}
    </FormHelperText>));
}

export function textFieldErrorProps(errors: FieldError[]): Partial<StandardTextFieldProps> {
  return {
    error: errors.length > 0,
    helperText: renderErrors(errors),
  };
}
